import { RemoteParticipant, Room } from 'livekit-client';
import { excludeAgents } from './participant';

export const createP2pPinger = (room: Room, hasRecorder: boolean) => {
    let pingInterval: number | undefined = undefined;

    const pingP2pOpponent = () => {
        if (hasRecorder) return;

        const remoteParticipants = excludeAgents<RemoteParticipant>(room.remoteParticipants);
        const isOnlyMeAndOpponent = remoteParticipants.size === 1;

        clearInterval(pingInterval);

        if (isOnlyMeAndOpponent) {
            // ping чтобы платформы могли понять находиться ли участник в звонке.
            pingInterval = window.setInterval(() => {
                room.localParticipant.publishData(new Uint8Array(), {
                    topic: 'ping',
                });
            }, 1000);
        } else {
            clearInterval(pingInterval);
        }
    };

    const stopPingP2pOpponent = () => {
        clearInterval(pingInterval);
    };

    return {
        pingP2pOpponent,
        stopPingP2pOpponent,
    };
};
